import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import { getOrganization } from '../../../lib/orgRequests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';

// Persists the loaded org config to localStorage so helpers in
// access.es6.js can read it synchronously (e.g. from renderers).
function cacheOrgConfig(orgData) {
  try {
    localStorage.setItem('org_config', JSON.stringify(orgData));
  } catch (e) {
    // localStorage quota — non-fatal
  }
}

// Watches SET_CURRENT_PARTNER: if the partner carries an organization_guid,
// fetch the org record and cache it so any renderer can read it without
// an extra API call.
export function* loadOrgConfigOnPartnerSwitchWatcher() {
  for (;;) {
    var action = yield take('SET_CURRENT_PARTNER');
    var partner = action.payload;
    var orgGuid = partner && partner.organization_guid;
    if (!orgGuid) {
      // Partner has no org — clear any stale config.
      localStorage.removeItem('org_config');
      yield put(actions.clearOrgConfig());
      continue;
    }
    yield put(actions.loadOrgConfigRequest(orgGuid));
    try {
      var response = yield call(getOrganization, orgGuid);
      cacheOrgConfig(response.data);
      yield put(actions.loadOrgConfigSuccess(response.data));
    } catch (e) {
      GAloggerException(e);
      yield put(actions.loadOrgConfigFailure(
        (e.response && e.response.data) || 'Failed to load org config'
      ));
    }
  }
}

// Also handles explicit LOAD_ORG_CONFIG_REQUEST dispatches (e.g. from tabs
// that need a forced refresh after an edit).
export function* loadOrgConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.LOAD_ORG_CONFIG_REQUEST);
    try {
      var response = yield call(getOrganization, request.payload);
      cacheOrgConfig(response.data);
      yield put(actions.loadOrgConfigSuccess(response.data));
    } catch (e) {
      GAloggerException(e);
      yield put(actions.loadOrgConfigFailure(
        (e.response && e.response.data) || 'Failed to load org config'
      ));
    }
  }
}
